import { yupResolver } from "@hookform/resolvers/yup";
import { UseFormProps, useForm } from "react-hook-form";
import * as yup from "yup";

type EmailSubscribeInputs = {
  email: string;
};

export function useEmailForm(options?: UseFormProps<EmailSubscribeInputs>) {
  const schema = yup
    .object({
      email: yup
        .string()
        .email()
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email domain",
        )
        .required(),
    })
    .required();

  const {
    register,
    reset,
    watch,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailSubscribeInputs, {}>({
    resolver: (data, context, options) => {
      data.email = data.email.trim();
      return yupResolver(schema)(data, context, options);
    },
    defaultValues: {
      email: "",
    },
    shouldUseNativeValidation: true,
    ...options,
  });

  return {
    register,
    watch,
    reset,
    clearErrors,
    handleSubmit,
    errors,
  };
}
